/*
8888888b.          888            888       888 d8b
888   Y88b         888            888   o   888 Y8P
888    888         888            888  d8b  888
888   d88P .d88b.  888888 .d88b.  888 d888b 888 888 888d888 .d88b.
8888888P" d88""88b 888   d88""88b 888d88888b888 888 888P"  d8P  Y8b
888 T88b  888  888 888   888  888 88888P Y88888 888 888    88888888
888  T88b Y88..88P Y88b. Y88..88P 8888P   Y8888 888 888    Y8b.
888   T88b "Y88P"   "Y888 "Y88P"  888P     Y888 888 888     "Y8888
*/

/*******************************************************
MAIN JAVASCRIPT FILE
This is the starting point for the javascript bundle. It's where all the interactions
for the site are stored. Any core modules needed by these interactions will be bundled
into the rotowire.min.js file by Browserify and Gulp. See gulpfile.js for specifics.
********************************************************/

import addAlljQueryPlugins from "./universal/jquery-plugins/all";
import handlePlayerSearchEvents from "./player-search/events";
import handleNavEvents from "./nav/events";
import handleNavigationEvents from "./navigation/events";
import handleUniversalEvents from "./universal/events";
import handleNFLEvents from "./sport-specific/nfl/events";
import handleNBAEvents from "./sport-specific/nba/events";
import handleNHLEvents from "./sport-specific/nhl/events";
import handlePGAEvents from "./sport-specific/pga/events";
import handleCBBEvents from "./sport-specific/cbb/events";
import handleCFBEvents from "./sport-specific/cfb/events";
import handleSoccerEvents from "./sport-specific/soccer/events";
import handleMLBEvents from "./sport-specific/mlb/events";
import handleWNBAEvents from "./sport-specific/wnba/events";
import handleEuroEvents from "./sport-specific/euro/events";

// Add jQuery Plugins
addAlljQueryPlugins();

$(() => {
  // Universal
  handleUniversalEvents();

  // Navigation
  handleNavigationEvents();
  handleNavEvents();

  // Player Search
  handlePlayerSearchEvents();

  // Sport-Specific
  handleNFLEvents();
  handleNBAEvents();
  handleNHLEvents();
  handlePGAEvents();
  handleCBBEvents();
  handleCFBEvents();
  handleSoccerEvents();
  handleMLBEvents();
  handleWNBAEvents();
  handleEuroEvents();
});
